import "@emotion/react";
import { Theme as MuiTheme } from "@mui/material";

declare module "@emotion/react" {
  // eslint tries to correct this into something invalid
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  export interface Theme extends MuiTheme {}
}

declare module "@mui/material/styles/createPalette" {
  interface PaletteOptions {
    buttonBorderColor?: string;
    chipOutlinedBorder?: string;
    link?: PaletteColorOptions;
    skeleton?: string;
    snackbar?: string;
  }

  interface Palette {
    link: PaletteColor;
    buttonBorderColor?: string;
    chipOutlinedBorder?: string;
    filledInputBackground?: string;
    outlinedBorder?: string;
    skeleton?: string;
    snackbar?: string;
  }

  interface TypeAction {
    deselected: string;
    deselectedLight: string;
  }
}

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    rounded?: true;
    roundedOutline?: true;
  }
  interface Button {
    rounded: true;
    roundedOutline: true;
  }
}

declare module "@mui/material/styles/createTypography" {
  interface TypographyOptions {
    fontWeightBook?: number;
    fontWeightSemiBold?: number;
  }
  interface Typography {
    fontWeightBook: number;
    fontWeightSemiBold: number;
  }
}

export type ThemeMode = "dark" | "light";

export const generateThemeOverrides = ({
  themeMode = "dark",
}: {
  themeMode: ThemeMode;
}) => {
  return {
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
          },
        },
      },
    },
    ...(themeMode === "light"
      ? {
          palette: {
            divider: "#babcbd",
          },
        }
      : {}),
    typography: {
      body1: {
        marginBottom: 0,
      },
      body2: {
        marginBottom: 0,
      },
      h5: {
        marginBottom: 0,
      },
    },
  };
};

export const getLegacyTypography = ({
  rootFontSize,
}: {
  rootFontSize: number;
}) => {
  return {
    typography: {
      htmlFontSize: rootFontSize,
    },
  };
};
